import { useEffect } from 'react';

export default function useSocketGizmo(scene, selectedObjectIds) {
    useEffect(() => {
      if (!scene || !Array.isArray(selectedObjectIds)) return;

      // scene.traverse ile tüm socket'leri bul (fpMesh altına reparent edilmişler dahil)
      scene.traverse(obj => {
        if (obj.userData?.type === 'socket') {
          const isSelected = selectedObjectIds.includes(obj.userData?.id);
          obj.traverse(child => {
            if (child.userData?.type === 'rotateGizmo' || child.userData?.type === 'stretchGizmo' || child.userData?.type === 'symetricGizmo') {
              child.visible = isSelected;
            }
          });
        }
      });
    }, [scene, selectedObjectIds]);
  }
  